import { GridColumnType } from "../../../../../data/gridColumnType";

export const MyTeamPlanningGridConfig = {
    columns: [
      {
        name: "Planning Title",
        fieldName: "planningTitle",
        allowShort: false,
        allowEditColumn: false,
        colStyle: {
          width: "25%"
        },
      },
      {
        name: "Start Date",
        fieldName: "startDate",
        allowShort: false,
        allowEditColumn: false,
        colType: GridColumnType.DATE,
        colSettings: {
          format: "DD/MM/YYYY",
        },
        colStyle: {
          width: "25%",
          textAlign: "center",
        },
        // editColumn: {
        //   editColType: EditGridColumnType.DATEPICKER,
        //   placeholder: "Please Select Start Date",
        //   editColFieldName: "startDate",
        //   isDisable: false,
        //   colConfig: {
        //     isReadOnly: false,
        //   },
        //   editColValidation: [
        //     { type: "required", message: "StartDate  is required." },
        //   ],
        // },
      },
      {
        name: "End Date",
        fieldName: "endDate",
        allowShort: false,
        allowEditColumn: false,
        colType: GridColumnType.DATE,
        colSettings: {
          format: "DD/MM/YYYY",
        },
        colStyle: {
          width: "25%",
          textAlign: "center",
        },
        // editColumn: {
        //   editColType: EditGridColumnType.DATEPICKER,
        //   placeholder: "Please Select End Date",
        //   editColFieldName: "endDate",
        //   isDisable: false,
        //   colConfig: {
        //     isReadOnly: false,
        //   },
        //   editColValidation: [
        //     { type: "required", message: "EndDate  is required." },
        //   ],
        // },
      },
      {
        name: "Working Days",
        fieldName: "workingDays",
        allowShort: false,
        allowEditColumn: false,
        colStyle: {
          width: "25%",
          textAlign: "center",
        },
        // editColumn: {
        //   editColType: EditGridColumnType.NUMERIC,
        //   placeholder: "Please Enter Working Days",
        //   editColFieldName: "workingDays",
        //   isDisable: false,
        //   colConfig: {
        //     isReadOnly: false,
        //   },
        //   editColValidation: [
        //     { type: "required", message: "WorkingDays  is required." },
        //   ],
        // },
      },
      {
        name: "Planning Status",
        fieldName: "statusName",
        allowShort: false,
        allowEditColumn: false,
        colType: GridColumnType.Text,
        colSettings: {
          // getLableClass: (value) => {
          //   const displayVal = value?.toString().toLowerCase();
          //   switch (displayVal) {
          //     case "1":
          //       return "Ongoing";
          //     case "2":
          //       return "Completed";
          //     case "3":
          //       return "Upcoming";
          //   }
          // },
        },
        colStyle: {
          width: "25%",
          textAlign: "center",
        },
      },
  
      {
        name: "Action",
        colType: GridColumnType.ACTION,
        defaultAction: {
          allowEdit: false,
          allowDelete: true,
        },
        customAction: [
          {
            name: "NEXT",
            iconClass: "streamline:next",
          },
        ],
        colStyle: {
          width: "150px",
          textAlign: "center",
        },
        allowShort: false,
      },
    ],
    editSettings: {
      buttons: {
        save: true,
        cancel: true,
      },
    },
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
  };